export const hashChangeMap: Map<
  string,
  (
    event: HashChangeEvent,
    target: HTMLElement,
    isNew: boolean,
    otherTarget: HTMLElement | null,
  ) => void
> = new Map();

function getHashTarget(hash: string): HTMLElement | null {
  if (/^#(?!:)/.test(hash)) {
    try {
      return document.querySelector(hash);
    } catch {
      // ignore
    }
  }

  return null;
}

function hashChangeHandler(e: HashChangeEvent) {
  const oldHash = !!e.oldURL ? new URL(e.oldURL).hash : '';
  const oldTarget = getHashTarget(oldHash);
  const newHash = !!e.newURL ? new URL(e.newURL).hash : '';
  const newTarget = getHashTarget(newHash);

  for (const [selector, handler] of hashChangeMap) {
    if (oldTarget && oldTarget.matches(selector)) {
      handler(e, oldTarget, false, newTarget);
    }

    if (newTarget && newTarget.matches(selector)) {
      handler(e, newTarget, true, oldTarget);
    }
  }
}

export function listen() {
  window.addEventListener('hashchange', hashChangeHandler);
  trigger();
}

export function trigger() {
  if (window.location.hash) {
    const change = new HashChangeEvent('hashchange', {
      newURL: window.location.href,
    });
    hashChangeHandler(change);
  }
}
